import React, { Component, Suspense } from "react";
import $ from "jquery";
import "react-datepicker/dist/react-datepicker.css";
import { apiCalling, apiUrlRelianceFunction } from "../apiService";
import moment from "moment";
// import ReactStars from "react-rating-stars-component";
import StarRatings from 'react-star-ratings';
import csv from "../image/icons/csv.png";
import Pagination from "react-js-pagination";
const folderName = window.sessionStorage.getItem("homeName");
const Header = React.lazy(() => import("../" + folderName + "/header"));
const Footer = React.lazy(() => import("../" + folderName + "/footer"));
export default class privillageReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            refferenceReport: [],
            csvFileDetails: [],
            totalCount: 0,
            activePage: 1,
            fuctionName: "Referral Report",
            showMessage: "Waiting for data... ",
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.hospitalReferrenceReport();
        this.hospitalCSVList();
    }
    handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        this.setState({ activePage: pageNumber });
        var offset;
        var max;
        if (pageNumber === "1") {
            offset = "0";
            max = "10";
            this.setState({
                activePage: pageNumber,
                isLoading: "0",
            });
        } else {
            offset = parseInt(pageNumber - 1) * 10;
            max = "10";
            this.setState({
                activePage: pageNumber,
                isLoading: "0",
            });
        }
        const apiJson = {
            method: "POST",
            body: JSON.stringify(
                {
                    "functionName": "idaPrivilegeCardReport",
                    doctorName: $("#hospitalSelect").val() == "doctorName" ? $("#txtHospital").val() : "",
                    storeCode: $("#hospitalSelect").val() == "storeCode" ? $("#txtHospital").val() : "",
                    mobileNumber: $("#hospitalSelect").val() == "mobileNumber" ? $("#txtHospital").val() : "",
                    category: $("#hospitalSelect").val() == "category" ? $("#txtHospital").val() : "",
                    storeName: $("#hospitalSelect").val() == "storeName" ? $("#txtHospital").val() : "",
                    offset: offset.toString(),
                    max: max
                })
        };
        $(".loader").show();
        let apiFunction = folderName !== null ? apiCalling : apiUrlRelianceFunction;
        apiFunction(apiJson).then((data) => {
            if (data.success == "1") {
                this.setState({
                    refferenceReport: data.result[0].resultData,
                    totalCount: data.result[0].resultDataCount,
                });
                $(".loader").hide();
            }
        });
    }
    hospitalReferrenceReport() {
        $(".loader").show();
        const apiJson =
        {
            method: "POST",
            body: JSON.stringify({
                functionName: "idaPrivilegeCardReport",
                doctorName: "",
                storeCode: "",
                mobileNumber: "",
                category: "",
                storeName: "",
                offset: "0",
                max: "10"
            }),
        };
        let apiFunction = folderName !== null ? apiCalling : apiUrlRelianceFunction;
        apiFunction(apiJson).then((data) => {
            $(".loader").hide();
            if (data.success === "1") {
                this.setState({
                    refferenceReport: data.result[0].resultData,
                    totalCount: data.result[0].resultDataCount,
                });
            }
            if (data.success === "0") {
                $(".loader").hide();
                this.setState({
                    refferenceReport: [],
                    showMessage: data.errorMessage,
                });
            }
        });
    }
    changeText = () => {
        if ($("#hospitalSelect").val() !== "0") {
            document.getElementById("txtHospital").disabled = false;
            $("input[name=txtHospital]").focus();
        } else {
            document.getElementById("txtHospital").disabled = true;
        }
        document.getElementById("txtHospital").value = "";
    };
    searchHandler() {
        let searchKeyWord = $("#txtHospital").val();
        let cmbCategory1 =
            $("#hospitalSelect").val() === "0" ? "" : $("#hospitalSelect").val();
        this.hospitalCSVList(searchKeyWord, cmbCategory1);
        if ($("#hospitalSelect").val() !== "0" && $("#txtHospital").val() === "") {
            var t = document.getElementById("hospitalSelect");
            var selectedText = t.options[t.selectedIndex].text;
            alert(selectedText + " Required");
            $("#txtHospital").focus();
            return false;
        } else {
            const searchData = {
                method: "POST",
                body: JSON.stringify(
                    {
                        functionName: "idaPrivilegeCardReport",
                        doctorName: $("#hospitalSelect").val() == "doctorName" ? $("#txtHospital").val() : "",
                        storeCode: $("#hospitalSelect").val() == "storeCode" ? $("#txtHospital").val() : "",
                        mobileNumber: $("#hospitalSelect").val() == "mobileNumber" ? $("#txtHospital").val() : "",
                        category: $("#hospitalSelect").val() == "category" ? $("#txtHospital").val() : "",
                        storeName: $("#hospitalSelect").val() == "storeName" ? $("#txtHospital").val() : "",
                        offset: "0",
                        max: "10"
                    }
                ),
            };
            $(".loader").show();
            let apiFunction =
                folderName !== null ? apiCalling : apiUrlRelianceFunction;
            apiFunction(searchData).then((data) => {
                $(".loader").hide();
                if (data.success === "1") {
                    this.setState({
                        refferenceReport: data.result[0].resultData,
                        totalCount: data.result[0].resultDataCount,
                        activePage: 1,
                    });
                }
                if(data.success === "1"&& data.result[0].resultDataCount==0){
                    this.setState({
                        showMessage:"NoData Found",
                    });
                }
                if (data.success === "0") {
                    $(".loader").hide();
                    this.setState({
                        refferenceReport: [],
                        showMessage: data.errorMessage,
                    });
                }
            });
        }
    }
    hospitalCSVList(searchKeyWord, cmbCategory1) {
        const searchData = {
            method: "POST",
            body: JSON.stringify({
                functionName: "idaPrivilegeCardReport",
                doctorName: cmbCategory1 == "doctorName" ? searchKeyWord : "",
                storeCode: cmbCategory1 == "storeCode" ? searchKeyWord : "",
                mobileNumber: cmbCategory1 == "mobileNumber" ? searchKeyWord : "",
                category: cmbCategory1 == "category" ? searchKeyWord : "",
                storeName: cmbCategory1 == "storeName" ? searchKeyWord : "",
                offset: "0",
                max: "10"
            }),
        };
        let apiFunction = folderName !== null ? apiCalling : apiUrlRelianceFunction;
        apiFunction(searchData).then((data) => {
            if (data.success === "1") {
                this.setState({
                    csvFileDetails: data.result[0].resultData,
                });
            }
            if (data.success === "0") {
                this.setState({
                    csvFileDetails: [],
                });
            }
        });
    }
    csvFileDownload() {
        const csvRow = [
            [
                "Doctor Name",
                "Doctor Mobile",
                "Doctor Email",
                "Store Name",
                "Store Code",
                "Store Contact",
                "Rating",
                "Category",
                "Amount",
            ],
        ];
        for (var item = 0; item < this.state.csvFileDetails.length; item++) {
            const re = this.state.csvFileDetails[item];
            csvRow.push([
                re.doctorName,
                re.mobileNumber,
                re.emailId,
                re.storeName,
                re.storeCode,
                re.storeContact,
                re.rating,
                re.category,
                re.amount,
            ]);
        }
        const csvString = csvRow.map(row => row.join(",")).join("%0A");
        const a = document.createElement("a");
        a.href = "data:attachment/csv," + csvString;
        a.target = "_blank";
        a.download = "Samrithi Connect Privilage Card Details" + ".csv";
        document.body.appendChild(a);
        a.click();
    }
    render() {
        return (
            <div class="purpleWrap">
                <Suspense fallback={<div>Waiting...</div>}>
                    <section>
                        {folderName !== null && <Header />}
                        <div className="loader"></div>
                        <div class="container">
                            <div class="main-wrapper1">
                                <div class="col-md-12 p-0">
                                    <ul class="breadcrumb">
                                        <li>
                                            <a
                                                href={
                                                    "/dashboard/reportDashboard/" +
                                                    this.props.match.params.groupHospitalId
                                                }
                                            >
                                                Reports
                                            </a>
                                            <i class="fa fa-chevron-right"></i>
                                        </li>
                                        <li>Samridhi Connect Privilege Card Report</li>
                                    </ul>
                                </div>
                                <div class="form-head">Samridhi Connect Privilege Card Report</div>
                                <div class="custom-search row">
                                    <div class="col-md-4 col-6 mb-3 custom-search-sub">
                                        <select
                                            class="input-design"
                                            id="hospitalSelect"
                                            name="hospitalSelect"
                                            onChange={() => this.changeText()}
                                        >
                                            <option value="0">- - Select - -</option>
                                            <option value="doctorName">Doctor Name</option>
                                            <option value="mobileNumber">Doctor Mobile Number</option>
                                            <option value="storeName">Store Name</option>
                                            {/* <option value="doctorEmail">Doctor Email</option> */}
                                            <option value="storeCode">
                                                Store Code
                                            </option>
                                            <option value="category"> Category</option>
                                            {/* <option value="referDrEmailId">
                        {" "}
                        Referral Dr Email-Id
                      </option> */}
                                        </select>
                                    </div>
                                    <div class="col-md-4 col-6 mb-3 custom-search-sub">
                                        <input
                                            type="text"
                                            class="input-design"
                                            id="txtHospital"
                                            name="txtHospital"
                                            disabled
                                        />
                                    </div>
                                    <div class="col-md-3 col-10 mb-3 custom-search-sub">
                                        <input
                                            type="submit"
                                            value="Search"
                                            class="formButton m-0"
                                            onClick={() => this.searchHandler()}
                                        />
                                    </div>
                                    <div className="col-md-1 col-2 mb-3 custom-search-sub p-0">
                                        <a
                                            onClick={() => this.csvFileDownload()}
                                            className="cursor-pointer"
                                        >
                                            <img
                                                src={csv}
                                                alt="csv"
                                                width="25"
                                                title="Export CSV"
                                                className="mt-1"
                                            />
                                        </a>
                                    </div>
                                </div>
                                {this.state.refferenceReport.length > 0 ? (
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th style={{ minWidth: "150px" }}>Doctor Name</th>
                                                    <th style={{ minWidth: "125px" }}>Doctor Mobile</th>
                                                    <th style={{ minWidth: "150px" }}>Doctor Email</th>
                                                    <th style={{ minWidth: "150px" }}>Store Name</th>
                                                    <th style={{ minWidth: "150px" }}>Store Code</th>
                                                    <th style={{ minWidth: "150px" }}>
                                                        Store Contact{" "}
                                                    </th>
                                                    <th style={{ minWidth: "150px" }}>
                                                        Rating
                                                    </th>
                                                    <th style={{ minWidth: "150px" }}>
                                                        Category
                                                    </th>
                                                    <th style={{ minWidth: "150px" }}>
                                                        Amount
                                                    </th>
                                                    {/* <th style={{ minWidth: "200px" }}>Created On</th> */}
                                                </tr>
                                            </thead>
                                            <tbody style={{ fontSize: "12px" }}>
                                                {this.state.refferenceReport.map((data) => {
                                                    //  let appointmentDate =moment(data.appointmentDate, "DD-MM-YYYY").format("DD-MMM-YYYY");
                                                    return (
                                                        <tr>
                                                            <td>{data.doctorName}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.emailId}</td>
                                                            <td>{data.storeName}</td>
                                                            <td>{data.storeCode}</td>
                                                            <td>{data.storeContact}</td>
                                                            <td> <StarRatings
                                                            starDimension="20px"
                                                            starSpacing="1px"
                                                            starRatedColor="#F4790B"
                                                                count={5}
                                                                rating={data.rating}
                                                                edit={false}
                                                            /></td>
                                                            {/* <td>{data.rating}</td> */}
                                                            <td>{data.category}</td>
                                                            <td>{data.amount}</td>
                                                            {/* <td>{data.createdOn}</td> */}
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                        {this.state.totalCount > 5 ? (
                                            <div className="paginationSection orderm-paginationSection">
                                                <Pagination
                                                    activePage={this.state.activePage}
                                                    itemsCountPerPage={10}
                                                    totalItemsCount={this.state.totalCount}
                                                    pageRangeDisplayed={10}
                                                    onChange={this.handlePageChange}
                                                />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                ) : (
                                    <p className="error-msg text-center mb-0">
                                        {" "}
                                        {this.state.showMessage}{" "}
                                    </p>
                                )}
                            </div>
                        </div>
                        {folderName !== null && <Footer />}
                    </section>
                </Suspense>
            </div>
        );
    }
}
